// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"d9772a0c","213":"3b18af56","258":"cabd4ac8","402":"2a5e51c2","667":"b568e7b5","855":"74d66fb8","941":"eda175d4"}[chunkId] + ".chunk.js";
};